export default __webpack_public_path__ + "a6a0f028dd0b215d90a6a4bcdf95c7b1.png";